export { default as asDeleteContactTagActionProps } from './asDeleteContactTagActionProps';
export { default as asDeleteContactTagActionInput } from './asDeleteContactTagActionInput';
export { default as DeleteContactTagActionComponent } from './DeleteContactTagActionComponent';
export { default as describeDeleteContactTagAction } from './describeDeleteContactTagAction';
export { default as defaultNewDeleteContactTagActionProps } from './defaultNewDeleteContactTagActionProps';
